import React, { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { ROUTE_ITINERARY_OPTIONS_DIALOG } from '../../../routes'
import { TAG_MULTIPATH_CTA } from '../../analytics/analytics.tagids.constants'
import { navigateTo } from '../../../store/history/history.actions'
import { MODAL_IDS } from '../../../store/ui/ui.constants'
import { selectHeaderHeight } from '../../../store/ui/ui.selectors'
import { selectShouldDisplayUserAccountIncentiveItineraryResults } from '../../../store/userAccount/userAccount.selectors'
import useConfigureAndSendTag from '../../analytics/useConfigureAndSendTag'
import { isGE } from '../../Device'
import { PUB_TAG } from '../../analytics/PublisherTagsService'
import Modal from '../../genericComponents/Modal'
import cross from '../../genericComponents/assets/cross.svg'
import gear from '../../genericComponents/assets/gear.svg'
import RectangleActionButton, { SIZE_MEDIUM } from '../../genericComponents/buttons/RectangleActionButton'
import T from '../../i18n/T'
import VehicleSettingsBox from '../../itineraryOptions/VehicleSettingsBox'
import SVGIcon from '../../svg/SVGIcon'
import useModal from '../../ui/useModal'
import { useAction } from '../../utils/react-redux'
import useEventCallback from '../../utils/useEventCallback'
import { withUserNotConnected } from '../shared/withKeycloak'
import s from './UserAccountIncentiveItineraryResults.less'
import { INCENTIVE_NAME } from './incentive.constants'

const getModalStyle = ({ headerHeight = 85 }) =>
  isGE()
    ? {
        top: headerHeight + 15,
        left: 430,
        transform: 'none',
        margin: 0
      }
    : {
        top: headerHeight + 53,
        left: 'auto',
        right: 5,
        transform: 'none',
        margin: 0
      }

const UserAccountIncentiveItineraryResults = () => {
  const headerHeight = useSelector(selectHeaderHeight)
  const shouldDisplay = useSelector(selectShouldDisplayUserAccountIncentiveItineraryResults)
  const { displayModal, hideModal } = useModal(MODAL_IDS.USER_ACCOUNT_INCENTIVE_ITINERARY_RESULTS)
  const { displayModal: displayIncentivePopinModal } = useModal(MODAL_IDS.USER_ACCOUNT_INCENTIVE_POPIN)
  const execNavigateTo = useAction(navigateTo)
  const configureAndSendTag = useConfigureAndSendTag()
  const modalStyle = useMemo(() => getModalStyle({ headerHeight }), [headerHeight])

  useEffect(() => {
    if (shouldDisplay) {
      displayModal()

      configureAndSendTag({
        type: TAG_MULTIPATH_CTA,
        tagInfo: { tag: PUB_TAG.PUB_COMPTE_PERSO_INCITATION, Incitation: INCENTIVE_NAME.incitationOptionReponse },
        isImpression: true
      })
    }
  }, [shouldDisplay])

  const onOptionsClick = useEventCallback(() => {
    execNavigateTo({ route: ROUTE_ITINERARY_OPTIONS_DIALOG })
    hideModal()
  })

  const onSaveClick = useEventCallback(() => {
    hideModal()
    displayIncentivePopinModal()
  })

  const onCloseClick = useEventCallback(() => {
    hideModal()
  })

  return (
    <Modal modalId={MODAL_IDS.USER_ACCOUNT_INCENTIVE_ITINERARY_RESULTS} style={modalStyle}>
      <div className={s.root}>
        <div className={s.title}>Calculez le coût précis du trajet 💰</div>
        <div className={s.form}>
          <VehicleSettingsBox modeId="car" />
        </div>
        <div className={s.button}>
          <RectangleActionButton label={'Enregistrer'} onClick={onSaveClick} size={SIZE_MEDIUM} />
        </div>
        <div className={s.closeBtn} onClick={onCloseClick}>
          <SVGIcon url={cross} />
        </div>
        <div className={s.optionsButton} onClick={onOptionsClick}>
          <div className="icon">
            <SVGIcon url={gear} />
          </div>
          <span>
            <T id={'itinerary.options'} />
          </span>
        </div>
      </div>
    </Modal>
  )
}

export default withUserNotConnected(UserAccountIncentiveItineraryResults)
